import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { CreateShareLink } from "../../../schemas/share-link";
import { queryKeys } from "../../query-keys";

export function useShareLinks(params?: { limit?: number; offset?: number }) {
	const limit = params?.limit ?? 25;
	const offset = params?.offset ?? 0;
	return useQuery({
		placeholderData: keepPreviousData,
		queryFn: () => adminApi.shareLinks.list({ limit, offset }),
		queryKey: queryKeys.shareLinks.list({ limit, offset }),
	});
}

export function useCreateShareLink() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: CreateShareLink) => adminApi.shareLinks.create(data),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.shareLinks.all }),
	});
}

export function useRevokeShareLink() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => adminApi.shareLinks.revoke(id),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.shareLinks.all }),
	});
}
